// extracted by mini-css-extract-plugin
export default {"footer":"app_footer__ZF9Wl","pageContent":"app_pageContent__fE2SZ"};